import React, { memo, useMemo } from "react";
import { Input, Select } from "antd";
import { dspxGetChildrens } from "../../helpers/dspx-utils";

import styles from "./AddressSelectGroup.module.scss";

const AddressSelectGroup = memo(
	({
		street,
		houses,
		streets,
		house,
		handleStreetChange,
		handleHouseChange,
		flats,
		streetWidth,
		houseWidth,
		flatWidth,
		withoutFlats,
		flat,
		handleFlatChange,
		multiple = false,
		streetsLoading = false,
		housesLoading = false,
		flatsLoading = false,
		showSearch = false,
		allowClear = true,
	}) => {
		const streetStyles = useMemo(() => ({ width: streetWidth }), [streetWidth]);
		const houseStyles = useMemo(() => ({ width: houseWidth }), [streetWidth]);
		const flatStyles = useMemo(() => ({ width: flatWidth }), [streetWidth]);
		return (
			<div className={styles.inputGroup}>
				<Input.Group compact>
					<Select
						mode={multiple && "multiple"}
						loading={streetsLoading}
						defaultActiveFirstOption={false}
						allowClear={allowClear}
						showSearch={showSearch}
						style={streetStyles}
						placeholder="Улица"
						notFoundContent="нет данных"
						value={street}
						onChange={handleStreetChange}
						optionLabelProp="label"
						optionFilterProp="searchtext"
						className={styles.streetSelect}
					>
						{dspxGetChildrens(streets)}
					</Select>
					<Select
						mode={multiple && "multiple"}
						loading={housesLoading}
						defaultActiveFirstOption={false}
						allowClear={true}
						style={houseStyles}
						notFoundContent="нет данных"
						placeholder="Дом"
						optionFilterProp="searchtext"
						value={house}
						onChange={handleHouseChange}
						className={styles.select}
					>
						{dspxGetChildrens(houses)}
					</Select>
					{!withoutFlats && (
						<Select
							mode={multiple && "multiple"}
							loading={flatsLoading}
							defaultActiveFirstOption={false}
							allowClear={true}
							notFoundContent="нет данных"
							style={flatStyles}
							placeholder="Кв./офис"
							value={flat}
							optionFilterProp="searchtext"
							onChange={handleFlatChange}
							className={styles.select}
						>
							{dspxGetChildrens(flats)}
						</Select>
					)}
				</Input.Group>
			</div>
		);
	}
);

export default AddressSelectGroup;